<svg fill="none" height="24" viewBox="0 0 20 24" width="20" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12 -0.000244141H2.4C1.08 -0.000244141 0 1.07976 0 2.39976V21.5998C0 22.9198 1.08 23.9998 
    2.4 23.9998H16.8C18.12 23.9998 19.2 22.9198 19.2 21.5998V7.19976L12 -0.000244141ZM10.8 14.0398V15.2398H6.96C6.96 
    15.4798 6.96 15.5998 6.96 15.8398C6.96 16.0798 6.96 16.1998 6.96 16.4398H10.8V17.6398H7.44C8.16 18.8398 9.36 19.6798 
    10.8 19.6798C11.76 19.6798 12.6 19.3198 13.32 18.7198L14.4 19.7998C13.44 20.6398 12.24 21.1198 10.8 21.1198C8.52 21.1198 
    6.6 19.6798 5.76 17.5198H3.6V16.3198H5.4C5.4 16.0798 5.4 15.9598 5.4 15.7198C5.4 15.4798 5.4 15.3598 5.4 15.1198H3.6V14.0398H5.76C6.48 
    11.9998 8.4 10.5598 10.8 10.5598C12.12 10.5598 13.44 11.0398 14.4 11.8798L13.32 12.9598C12.6 12.3598 11.76 11.9998 10.8 11.9998C9.36 
    11.9998 8.04 12.8398 7.44 14.0398H10.8ZM11.28 7.91976V1.79976L17.4 7.91976H11.28Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
